"use client";

var __jsx = React.createElement;
import React, { useMemo } from "react";
import "styles/components/buttons/muscle-button.css";
import { cn } from "@lib/cn";
import Icons from "@modules/icons";
import useCssModules from "@lib/hooks/use-css-modules";
const MuscleButton = _ref => {
  let {
    isLoading = false,
    disabled = false,
    variant = "solidMd",
    onClick = () => {},
    onTouchStart = () => {},
    onTouchEnd = () => {},
    children,
    text,
    className = "",
    type = "button",
    dataTestId,
    id
  } = _ref;
  const {
    cssModules
  } = useCssModules();
  const classes = cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.muscleButton;
  const variantClass = {
    solidXs: classes === null || classes === void 0 ? void 0 : classes.solidXs,
    outlineXs: classes === null || classes === void 0 ? void 0 : classes.outlineXs,
    ghostXs: classes === null || classes === void 0 ? void 0 : classes.ghostXs,
    solidSm: classes === null || classes === void 0 ? void 0 : classes.solidSm,
    outlineSm: classes === null || classes === void 0 ? void 0 : classes.outlineSm,
    ghostSm: classes === null || classes === void 0 ? void 0 : classes.ghostSm,
    solidMd: classes === null || classes === void 0 ? void 0 : classes.solidMd,
    outlineMd: classes === null || classes === void 0 ? void 0 : classes.outlineMd,
    ghostMd: classes === null || classes === void 0 ? void 0 : classes.ghostMd,
    solidLg: classes === null || classes === void 0 ? void 0 : classes.solidLg,
    outlineLg: classes === null || classes === void 0 ? void 0 : classes.outlineLg,
    ghostLg: classes === null || classes === void 0 ? void 0 : classes.ghostLg,
    solidXL: classes === null || classes === void 0 ? void 0 : classes.solidXL,
    outlineXL: classes === null || classes === void 0 ? void 0 : classes.outlineXL,
    ghostXL: classes === null || classes === void 0 ? void 0 : classes.ghostXL,
    link: classes === null || classes === void 0 ? void 0 : classes.link,
    tag: classes === null || classes === void 0 ? void 0 : classes.tag
  }[variant];
  const _className = useMemo(() => cn("flex items-center gap-2", variantClass, disabled && "bg-opacity-60 border-transparent text-opacity-60 cursor-not-allowed", disabled && (classes === null || classes === void 0 ? void 0 : classes.disabled)), [variantClass, disabled, className]);
  return __jsx("button", {
    id: id,
    "data-testid": dataTestId,
    className: cn(_className, className),
    onClick: onClick,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    disabled: disabled || isLoading,
    type: type
  }, children, text && __jsx("span", null, text), isLoading && __jsx(Icons.spinner, {
    className: "w-6 h-6"
  }));
};
export default MuscleButton;